import { useCart, getCartItemKey } from "../../Contexts/CartContext";
import { FaShoppingBag, FaTrash } from "react-icons/fa";
import CartProductItem from "../CartProductItem/CartProductItem";
import Button from "../Button/Button";

const CartStep = () => {
  const { cartItems, clearCart } = useCart();

  return (
    <div className="flex flex-col bg-white border rounded shadow p-4 flex-[1.6]">
      <div className="flex flex-col sm:flex-row items-center justify-between pb-5 border-b">
        <div className="flex items-center gap-2 mb-4 sm:mb-5">
          <FaShoppingBag className="text-primary-600" />
          <h4 className="text-md font-semibold">PRODUTOS</h4>
        </div>
        <Button variant="secondary" 
          className="w-full sm:w-auto flex items-center justify-center text-xs gap-1 py-3 sm:py-2 px-4"
          onClick={clearCart}
        >
          <FaTrash />
          REMOVER TODOS OS PRODUTOS
        </Button>
      </div>
      <div className="flex-1 overflow-y-auto">
        <div className="grid auto-rows-fr">
          {cartItems.map(item => (
            <CartProductItem
              key={getCartItemKey(item)}
              item={item}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default CartStep;
